module.exports = __webpack_public_path__ + "img/sjs-1.89684e6e.png";